import React, { createContext, useState, useEffect } from 'react';
import {jwtDecode} from 'jwt-decode';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [tokens, setTokens] = useState(null);
  const [loading, setLoading] = useState(true); // Add a loading state

  // Function to validate token
  const isTokenValid = (token) => {
    if (!token) return false;

    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      return decoded.exp > currentTime;
    } catch (error) {
      console.error('[AuthContext] Invalid token:', error);
      return false;
    }
  };

  // Function to login user
  const login = ({ tokens, user }) => {
    setTokens(tokens); // Update token state
    setUser(user); // Update user state
    localStorage.setItem('authData', JSON.stringify({ tokens, user })); // Persist to localStorage
  };

  const logout = () => {
    setUser(null);
    setTokens(null);
    localStorage.removeItem('authData');
    console.info('[AuthContext] User logged out.');
  };

  // On app load, rehydrate tokens and user
  useEffect(() => {
    const storedAuthData = localStorage.getItem('authData');
    if (storedAuthData) {
      const { tokens, user } = JSON.parse(storedAuthData);
      if (isTokenValid(tokens?.access_token)) {
        console.info('[AuthContext] Restoring user session.');
        setTokens(tokens);
        setUser(user);
      } else {
        console.warn('[AuthContext] Stored tokens are invalid or expired. Clearing data.');
        logout();
      }
    }
    setLoading(false); // Set loading to false after checking
  }, []);

  return (
    <AuthContext.Provider value={{ user, tokens, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
